<template>
  <div class="wrapper-configs">
    <label class="fs-21">{{ $t('compartilhados.SmartTable.Configs.titulo') }}</label>

    <h5>{{ $t('compartilhados.SmartTable.Configs.ordemDosCampos') }}</h5>
    <draggable
      v-model="configs.headerItems"
      class="grid"
      item-key="column"
      direction="horizontal"
      draggable=".draggable"
    >
      <template #item="{ element }">
        <div class="column" :class="{ draggable: isItemMovable(element) }">
          <img
            v-if="isItemMovable(element)"
            src="https://cdn.iconscout.com/icon/free/png-256/drag-indicator-1782445-1512354.png"
          >

          <template v-if="isItemHiddable(element)">
            <PCheckbox v-model="element.isToShow" :label="element.column" />
          </template>

          <template v-else>
            {{ element.column }}
          </template>
        </div>
      </template>
    </draggable>

    <PontotelBotao peso="pesado" :tipo="corDoBotaoSalvar" tamanho="M" @clique="apply" :desabilitado="!validToSave">
      {{ $t('compartilhados.SmartTable.Configs.botaoSalvar') }}
    </PontotelBotao>
    <PontotelBotao tipo="neutro" tamanho="M" @clique="close">
      {{ $t('compartilhados.SmartTable.Configs.botaoCancelar') }}
    </PontotelBotao>
    <PontotelBotao tipo="info" tamanho="M" @clique="reset">
      {{ $t('compartilhados.SmartTable.Configs.botaoVoltarPadrao') }}
    </PontotelBotao>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { configHelpers } from './layout'

export default {
  name: 'Configs',
  components: {draggable},
  props: {
    name: {type: String, required: true},
    headerItems: {type: Array, required: true},
    config: {type: Object, required: true}
  },
  created () {
    this.configs = configHelpers.getConfigs(this.name, this.headerItems)
  },
  data () {
    return {
      configs: {
        headerItems: []
      }
    }
  },
  computed: {
    validToSave () {
      // only allow user to save if theres 4 or more itens set to be displayed
      // otherwise the layout could end really broken
      return this.configs.headerItems.filter(i => i.isToShow).length >= 4
    },
    corDoBotaoSalvar () {
      if (this.validToSave) {
        return 'primario'
      }
      return 'neutro'
    }
  },
  methods: {
    isItemMovable (item) {
      return item.userCustom?.movable !== undefined ? item.userCustom.movable : true
    },
    isItemHiddable (item) {
      return item.userCustom?.hiddable !== undefined ? item.userCustom.hiddable : true
    },
    close () {
      this.$emit('close')
    },
    apply () {
      if (!this.validToSave) {
        return
      }

      const configs = configHelpers.saveConfigs(this.name, this.configs)
      this.$emit('close')
      this.$emit('applyConfigs', configs)
    },
    reset () {
      localStorage.removeItem(configHelpers.storageName(this.name))
      this.$emit('applyConfigs', this.configs)
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.sortable-ghost { opacity: 0; }

.wrapper-configs {
  h5 {
    margin: 10px;
  }

  .grid {
    width: 100%;
    display: grid;
    grid-auto-flow: column;
    margin-bottom: 10px;
    border-top: 2px solid var(--color-primary);
    border-bottom: 2px solid var(--color-primary);

    .column {
      /*width: 100px;*/
      padding: 5px;
      position: relative;
      user-select: none;
      align-items: center;

      display: grid;
      grid-template-columns: 0.2fr minmax(0, 1fr);

      img {
        display: inline;
        height: 20px;
        opacity: 0.3;
        cursor: grab;
      }
    }
  }
}
</style>
